var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    clipPath: "url(#clip0_2511_148755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "username"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 10.9152,
    cy: 8.41127,
    r: 2.94643,
    stroke: "#848A9B",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 41",
    d: "M15.2809 16.7463C15.2809 14.1164 13.3266 11.9844 10.9159 11.9844C8.50509 11.9844 6.55078 14.1164 6.55078 16.7463",
    stroke: "#848A9B",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 10.9154,
    cy: 10.0013,
    r: 7.70833,
    stroke: "#848A9B",
    strokeWidth: 1.25
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2511_148755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1081,
    height: 20,
    fill: "white",
    transform: "translate(0.917969)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.001e8ef086b22997862a436c4a4a88d4.svg";
export { ForwardRef as ReactComponent };